import axios from 'axios'
import { ADD_NEW_EMPLOYEE_URL } from './consts'
import { INewEmployeeResponse } from './types'

export const addNewEmployee = (
  uuid: string,
  password: string,
  role: string,
  cashboxId?: any,
  merchantId?: any,
  merchantIds?: number[]
) => {
  const finalCashboxId = (typeof cashboxId === 'number' && !isNaN(cashboxId))
    ? cashboxId
    : (typeof cashboxId === 'string' && !isNaN(Number(cashboxId)))
      ? Number(cashboxId)
      : null

  const finalMerchantId = (typeof merchantId === 'number' && !isNaN(merchantId))
    ? merchantId
    : (typeof merchantId === 'string' && !isNaN(Number(merchantId)))
      ? Number(merchantId)
      : null

  return axios.post<INewEmployeeResponse>(ADD_NEW_EMPLOYEE_URL, {
    uuid,
    password,
    role,
    cashboxId: finalCashboxId,
    merchantId: finalMerchantId,
    merchantIds: merchantIds && merchantIds.length > 0 ? merchantIds : null,
    enabled: true,
  })
}
